import {render} from './interscroller';
import {publish} from '../../utils/pubsub';

export function loadCustomCreative(data) {
	if (data.action === 'showInterscroller') {
		render(data.options);
	} else {
		publish(data.action, data.options);
	}
}
